import { S128gS128m01Component } from './s128g-s128m01.component';

export { S128gModule } from './s128g.module';

export const S128gSubComponentsMap = {
	
};

export const S128gComponentsMap = {
	"s128g-s128m01": S128gS128m01Component
};

export const S128gComponents = [
	S128gS128m01Component
];

